import { createSlice } from '@reduxjs/toolkit';

const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    isFilterOpen: false, 
  },
  reducers: {
    toggleFilter: (state) => {
      state.isFilterOpen = !state.isFilterOpen;
    },
    resetFilter: (state) => {
      state.isFilterOpen = false; // Reset to false
    },
  },
});

export const { toggleFilter, resetFilter } = filterSlice.actions;
export default filterSlice.reducer;
